export const isUndefined = <T>(object: T | undefined): object is undefined => object === undefined
